module.exports = __webpack_public_path__ + "img/1-17.cf31b401.png";